import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import './GameOverModal.css';
import CONSTANTS, { computeBasedness } from './constants';
import { useLegacyAuth } from '../../hooks/useLegacyAuth';


function GameOverModal({ isTestLevel, onClose, forceClosed, gameState, gameStats, name, levelDetails, levelID, gamePlayUUID, hasReplaySession, replayResult, autoplay}) {
    const modalRef = useRef();
    const navigate = useNavigate();
    const [isPublished, setIsPublished] = useState(false);
    const [isPublishing, setIsPublishing] = useState(false);

    // Get auth state via legacy hook (supports both new auth and legacy localStorage)
    const { twitterUser } = useLegacyAuth();

    const [basednessLevel, basedness_img_url] = computeBasedness(gameStats.totalScore, levelDetails.LEVEL_NAME);
    const levelClass = `level-${levelID}`;

    // Check if score was successfully validated and saved
    const hasValidScore = replayResult?.score_id != null;
    const validationErrors = replayResult?.validation_errors;

    const handleSaveToLeaderboard = async () => {
        if (!gamePlayUUID || isPublishing || isPublished || !hasValidScore) return;

        setIsPublishing(true);
        try {
            const response = await fetch(`/api/replay/sessions/${gamePlayUUID}/publish`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Failed to publish replay');
            }

            setIsPublished(true);
        } catch (error) {
            console.error('Error publishing replay:', error);
            alert('Failed to save replay to leaderboard');
        } finally {
            setIsPublishing(false);
        }
    };

    if (forceClosed || (gameState !== CONSTANTS.GAME_STATE_COMPLETE && gameState !== CONSTANTS.GAME_STATE_ENDING)) {
        return null;
    }
    
    return (
        <div className={`gameOverModalOverlay ${levelClass}`}>
            <div className={`gameOverModalContent ${levelClass}`} ref={modalRef}>
            <div><b>congrats {twitterUser?.screen_name || name || "anon"}!</b></div>
            <div className="equalWidthContainer">
            <div className="leftSection">
                    <img src={basedness_img_url} alt="Score Icon" className="scoreImage"/>
            </div>
            <div style={{fontSize: '0.7em'}} className="rightSection">
            <div>level: {levelDetails.LEVEL_NAME}</div>
            <div>total score: {gameStats.totalScore}</div>


                <div>basedness Level: {basednessLevel}</div>
                {
                    levelID === 'tiny_dino' ? (
                        <div># of rawrizard Used: {gameStats.powerUps}</div>
                    ) : levelID === 'nakamigo_crush' ? (
                        <div># of king Spartans Used: {gameStats.powerUps}</div>
                    ) : levelID === 'book_of_bee' ? (
                        <div># of power up's used: {gameStats.powerUps}</div>
                    ) : (
                        <div># of power up's used: {gameStats.powerUps}</div>
                    )
                }
        </div>
    </div>
                {/* Conditionally render the credits section */}
                {levelDetails.CREDITS && levelDetails.CREDITS.length > 0 && (
                    <div className="creditsSection"> {/* Wrap the credits section */}
                        <table>
                            <thead>
                                <tr>
                                    <th>Credits</th>
                                </tr>
                            </thead>
                            <tbody>
                                {levelDetails.CREDITS.map((credit, index) => (
                                    <tr key={index}>
                                        <th style={{fontSize: '0.7em'}}>
                                            {credit.key}:
                                        </th>
                                        <td style={{fontSize: '0.7em'}}>{credit.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                <div style={{display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '10px', flexWrap: 'wrap'}}>
                    {gamePlayUUID && (!isTestLevel || autoplay) && hasReplaySession && !isPublished && gameState === CONSTANTS.GAME_STATE_COMPLETE && (
                        <>
                            {validationErrors && validationErrors.length > 0 && (
                                <div style={{width: '100%', textAlign: 'center', color: '#d32f2f', fontSize: '0.8em', marginBottom: '10px'}}>
                                    Score validation failed: {validationErrors.join(', ')}
                                </div>
                            )}
                            {!hasValidScore && !validationErrors && (
                                <div style={{width: '100%', textAlign: 'center', fontSize: '0.8em', marginBottom: '10px'}}>
                                    Validating score...
                                </div>
                            )}
                            <button
                                className={`close-button ${levelClass}`}
                                onClick={handleSaveToLeaderboard}
                                disabled={isPublishing || !hasValidScore}
                                style={{opacity: (!hasValidScore || isPublishing) ? 0.5 : 1}}
                            >
                                {isPublishing ? 'Saving...' : 'Save Replay to Leaderboard'}
                            </button>
                        </>
                    )}
                    {gamePlayUUID && (!isTestLevel || autoplay) && hasReplaySession && isPublished && (
                        <>
                            <button
                                className={`close-button ${levelClass}`}
                                onClick={() => {
                                    navigate(`/mfersbeheaded/replay/${gamePlayUUID}`);
                                }}
                            >
                                Go to Replay
                            </button>
                            <button
                                className={`close-button share-x-button ${levelClass}`}
                                onClick={() => {
                                    const replayUrl = `${window.location.origin}/mfersbeheaded/replay/${gamePlayUUID}`;
                                    const finalScore = gameStats.totalScore;
                                    const tweetText = `🎮 Just crushed ${levelDetails.LEVEL_NAME} on mfers arcade!\n\n🎯 Score: ${finalScore}\n\nWatch the replay and see if you can beat it! 👇`;
                                    const twitterIntentUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(tweetText)}&url=${encodeURIComponent(replayUrl)}`;
                                    window.open(twitterIntentUrl, '_blank', 'noopener,noreferrer');
                                }}
                            >
                                <img src="/images/x-logo-black.png" alt="X" className="x-logo-small-button" />
                                Share on 𝕏
                            </button>
                        </>
                    )}
                    <button className={`close-button ${levelClass}`} onClick={onClose}>Close</button>
                </div>
            </div>
        </div>
    );
    
    
    
}

GameOverModal.propTypes = {
    isTestLevel: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    forceClosed: PropTypes.bool,
    gameState: PropTypes.number.isRequired,
    gameStats: PropTypes.shape({
        totalScore: PropTypes.number.isRequired,
        powerUps: PropTypes.number
    }).isRequired,
    name: PropTypes.string,
    levelDetails: PropTypes.shape({
        LEVEL_NAME: PropTypes.string,
        LEVEL_VERSION: PropTypes.string,
        CREDITS: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            value: PropTypes.string
        }))
    }).isRequired,
    levelID: PropTypes.string.isRequired,
    gamePlayUUID: PropTypes.string.isRequired,
    hasReplaySession: PropTypes.bool,
    replayResult: PropTypes.shape({
        success: PropTypes.bool,
        score_id: PropTypes.number,
        validated_score: PropTypes.number,
        validation_errors: PropTypes.arrayOf(PropTypes.string)
    }),
    autoplay: PropTypes.bool
};

export default GameOverModal;